import React from 'react';
import { motion } from 'framer-motion';
import { submarineImages } from '../data/mock';
import SectionTitle from './SectionTitle';

const items = [
  { src: submarineImages.exterior1, label: 'EXTERİOR / 01', code: 'IMG-001', tall: false },
  { src: submarineImages.tech1, label: 'POWERPLANT', code: 'IMG-002', tall: true },
  { src: submarineImages.periscope1, label: 'PERİSCOPE', code: 'IMG-003', tall: false },
  { src: submarineImages.interior, label: 'İNTERİOR', code: 'IMG-004', tall: false },
  { src: submarineImages.tech2, label: 'CONTROL ROOM', code: 'IMG-005', tall: true },
  { src: submarineImages.periscope3, label: 'OPTRONİC MAST', code: 'IMG-006', tall: false },
];

export default function Gallery() {
  return (
    <section id="gallery" className="relative py-24 md:py-32 overflow-hidden bg-[#070b12]">
      <div className="absolute inset-0 bg-grid opacity-30" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <SectionTitle code="SECTION / 05" title="GÖRSEL ARSİV" subtitle="İnşa, test ve görev süreçlerinden seçilmiş belge görüntüleri." />

        <div className="mt-16 grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
          {items.map((it, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-50px' }}
              transition={{ duration: 0.6, delay: (i % 3) * 0.1 }}
              className={`group relative overflow-hidden border border-cyan-500/15 bg-[#0a0f17] ${
                it.tall ? 'row-span-2 aspect-[3/5]' : 'aspect-[4/3]'
              }`}
            >
              <span className="corner-mark corner-tl !w-3 !h-3" />
              <span className="corner-mark corner-tr !w-3 !h-3" />
              <span className="corner-mark corner-bl !w-3 !h-3" />
              <span className="corner-mark corner-br !w-3 !h-3" />
              <img
                src={it.src}
                alt={it.label}
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                style={{ filter: 'grayscale(0.3) contrast(1.05)' }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#05080d] via-transparent to-transparent opacity-80" />
              <div className="absolute inset-0 bg-grid-fine opacity-0 group-hover:opacity-30 transition-opacity" />
              <figcaption className="absolute bottom-3 left-3 right-3 flex items-center justify-between text-[10px] font-mono tracking-[0.2em]">
                <span className="text-cyan-300">{it.label}</span>
                <span className="text-cyan-400/50">{it.code}</span>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
